import { zCallMonitoringData } from '@repo/sdk/zod'
import { ListLayout } from '@repo/ui/components/list-layout'
import { createFileRoute, stripSearchParams } from '@tanstack/react-router'
import { z } from 'zod'
import { useTranslation } from '@/lib/i18n'
import { MonitoringFilters } from './-components/monitoring-filters'
import { MonitoringTable } from './-components/monitoring-table'

const filterShape = zCallMonitoringData.shape.body.shape.filters.unwrap().shape

const searchSchema = z.object({
	search: z.string().trim().default(''),
	state: filterShape.state,
	anno: z
		.string()
		.regex(/^\d{4}-\d{4}$/)
		.optional()
		.catch(undefined)
})

export const Route = createFileRoute('/(private)/bandi/')({
	component: MonitoringPage,
	validateSearch: searchSchema,
	search: {
		middlewares: [stripSearchParams(searchSchema.parse({}))]
	}
})

/**
 * "Bandi" (FFD 3.6): every residence with a published call, the late ones
 * first, so the general admin sees at a glance who holds the ranking back and
 * reminds them. No command here changes an outcome.
 */
function MonitoringPage() {
	const { t } = useTranslation()
	return (
		<ListLayout
			controlsSlot={<MonitoringFilters />}
			listSlot={<MonitoringTable />}
			title={t('admin-monitoring:page_title')}
		/>
	)
}
